import { render, staticRenderFns } from "./checklistItem.vue?vue&type=template&id=e5430fde&scoped=true"
import script from "./checklistItem.vue?vue&type=script&lang=js"
export * from "./checklistItem.vue?vue&type=script&lang=js"
import style0 from "./checklistItem.vue?vue&type=style&index=0&id=e5430fde&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5430fde",
  null
  
)

export default component.exports